(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
    this.headerBounds = {};

    this.setHeaderHeight();
    this.setHeaderHeightLive();

    window.addEventListener('resizeend', this.setHeaderHeight.bind(this));
    window.addEventListener('resizeend', this.setHeaderHeightLive.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.lastScrollTrigger = 0;
    this.scrollThreshold = 50;

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, { passive: true });

    this.searchButton = this.querySelector('.header__icon--search');
    if (this.searchButton) {
      this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
    }

    this.createObserver();
  }

  searchButtonClick() {
    this.preventHide = true;
    requestAnimationFrame(() => { this.preventHide = false; });
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  setHeaderHeightLive(event, zero) {
    document.documentElement.style.setProperty('--header-height-live', `${zero ? 0 : this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    requestAnimationFrame(() => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Only trigger actions if the scroll has changed by at least the threshold value
      if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

      const scrollDifference = scrollTop - this.currentScrollTop;
      // Handle scrolling classes based on 50px sensitivity
      if (scrollDifference > 50 && this.pauseScrollListen !== true) {
        // Scrolling down
        this.pauseScrollListen = true;
        this.header.classList.add('scrolling-down');
        this.header.classList.remove('scrolling-up');
        setTimeout(() => {
          this.setHeaderHeightLive();
          this.pauseScrollListen = false;
        }, 320);
      } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
        // Scrolling up
        this.pauseScrollListen = true;
        this.header.classList.add('scrolling-up');
        this.header.classList.remove('scrolling-down');
        setTimeout(() => {
          this.setHeaderHeightLive();
          this.pauseScrollListen = false;
        }, 320);
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        // Main logic for scrolling down
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        // Main logic for scrolling up
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        // Reset at the top
        this.header.classList.remove('scrolled-past-header');
        this.header.classList.remove('scrolling-down');
        this.header.classList.remove('scrolling-up');
        requestAnimationFrame(this.reset.bind(this));
        setTimeout(() => {
          this.setHeaderHeightLive();
        }, 320);
      }

      this.currentScrollTop = scrollTop;
      this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
    });
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
    this.setHeaderHeightLive(null, true);
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
    this.setHeaderHeightLive();
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal?.close?.(false);
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
